import { render, staticRenderFns } from "./CreateFeedContainerFiles.vue?vue&type=template&id=6debd562&"
import script from "./CreateFeedContainerFiles.vue?vue&type=script&lang=ts&"
export * from "./CreateFeedContainerFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports